/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { CellValueUnion } from "../../types/CellValueUnion";
export const FindAndReplaceRecordRequest = core.serialization.object({
    find: CellValueUnion.optional(),
    replace: CellValueUnion.optional(),
    fieldKey: core.serialization.string(),
});
